import React from 'react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="bg-ice py-5 sm:py-7" data-id="element-17" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-18" data-mp="pjg4xyy2x3zv">
        <h2 className="text-center text-3xl leading-none text-navy sm:text-5xl" data-id="element-19" data-mp="avcv2egx185s">
          5 PREMIUM BONUSES <span className="text-tech" data-id="element-20" data-mp="ftwi6i78wpzq">INCLUDED</span>
        </h2>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-21" data-mp="fs3ar0ot61qo">
          {bonuses.map((bonus, i) => <article key={bonus.label} className={`rounded-xl border border-metal/60 bg-white p-3 shadow-sm sm:p-4 ${i === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-22" data-mp="1wriczy4kncx" data-mpi={i}>
              <h3 className="flex flex-wrap items-center gap-x-2 gap-y-1 text-base leading-tight text-navy sm:text-lg" data-id="element-23" data-mp="3t1ra6gqx7o5r">
                <span className="rounded-md bg-gold px-2 py-0.5 font-display text-xs font-extrabold tracking-wide text-navy" data-id="element-24" data-mp="1marudowlkc42">
                  {bonus.label}
                </span>
                <span data-id="element-25" data-mp="3idely5fza24v">— {bonus.title}</span>
              </h3>
              <p className="mt-1 text-sm leading-snug text-steel" data-id="element-26" data-mp="3dfd1ph6tfwrt">{bonus.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}